
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Almadaa Digital', path: '/almadaa-digital' },
    { name: 'Dennywise Travel', path: '/dennywise-travel' },
    { name: 'Goals & Aim', path: '/goals' },
    { name: 'Why Choose Us', path: '/why-choose-us' },
    { name: 'Affiliate Program', path: '/affiliate-program' },
    { name: 'ARK CARE Foundation', path: '/ark-care-foundation' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <nav className="max-w-full mx-auto px-4 sm:px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Logo - Optimized with proper constraints */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/abcfde42a70d25526c2b82811ba21d87/0ba5fb94409f55e3f47bcb587233afbd.png"
              alt="Afriq Global Logo"
              className="h-12 sm:h-14 md:h-16 w-auto max-h-16 object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            <Link 
              to="/" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              About
            </Link>
            <Link 
              to="/almadaa-digital" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Almadaa Digital
            </Link>
            <Link 
              to="/dennywise-travel" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Afriq Travel
            </Link>
            <Link 
              to="/ark-care-foundation" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              ARK CARE
            </Link>
            <Link 
              to="/goals" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Goals
            </Link>
            <Link 
              to="/why-choose-us" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Why Choose Us
            </Link>
            <Link 
              to="/affiliate-program" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              Affiliate Program
            </Link>
            <Link 
              to="/contact" 
              className="px-5 py-2 bg-yellow-500 hover:bg-yellow-600 text-black text-sm font-bold rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-gray-900 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 py-4 bg-white rounded-lg shadow-xl">
            <div className="flex flex-col space-y-3 px-6">
              <Link 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-900 hover:text-yellow-500 text-sm font-semibold transition-colors cursor-pointer"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-900 hover:text-yellow-500 text-sm font-semibold transition-colors cursor-pointer"
              >
                About
              </Link>
              <Link 
                to="/almadaa-digital" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-900 hover:text-yellow-500 text-sm font-semibold transition-colors cursor-pointer"
              >
                Almadaa Digital
              </Link>
              <Link 
                to="/dennywise-travel" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-900 hover:text-yellow-500 text-sm font-semibold transition-colors cursor-pointer"
              >
                Afriq Travel
              </Link>
              <Link 
                to="/ark-care-foundation" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-900 hover:text-yellow-500 text-sm font-semibold transition-colors cursor-pointer"
              >
                ARK CARE
              </Link>
              <Link 
                to="/goals" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-900 hover:text-yellow-500 text-sm font-semibold transition-colors cursor-pointer"
              >
                Goals
              </Link>
              <Link 
                to="/why-choose-us" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-900 hover:text-yellow-500 text-sm font-semibold transition-colors cursor-pointer"
              >
                Why Choose Us
              </Link>
              <Link 
                to="/affiliate-program" 
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-900 hover:text-yellow-500 text-sm font-semibold transition-colors cursor-pointer"
              >
                Affiliate Program
              </Link>
              <Link 
                to="/contact" 
                onClick={() => setIsMenuOpen(false)}
                className="px-5 py-2 bg-yellow-500 hover:bg-yellow-600 text-black text-sm font-bold rounded-lg transition-all text-center cursor-pointer"
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
